export default __webpack_public_path__ + "assets/76efa92f0dad9de0619546126cc37697.jpg";